import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }

import { computed, ref } from "vue";
import BottomSheet from "@/components/Modals/BottomSheet.vue";
import EditCategories from "@/components/Form/EditCategories.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import MediumText from "@/components/Texts/MediumText.vue";
import SmallText from "@/components/Texts/SmallText.vue";
import ExtraSmallText from "@/components/Texts/ExtraSmallText.vue";
import InputTextarea from "@/components/Form/Common/InputTextarea.vue";
import PrimaryButton from "@/components/Form/Common/PrimaryButton.vue";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";
import SecondaryButton from "@/components/Form/Common/SecondaryButton.vue";
import ErrorText from "@/components/Texts/ErrorText.vue";
import SuccessText from "@/components/Texts/SuccessText.vue";
import InputSelectOption from "@/components/Form/Common/InputSelectOption.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSuggestionActions',
  props: {
    dialogId: {}
  },
  setup(__props: any) {

const props = __props;

const gameStore = useGameStore();

const textValue = ref("");
const categoryId = ref(1);

const successAction = ref(false);

const onSubmit = () => {
  successAction.value = false;
  gameStore.addSuggestionAction(textValue.value, categoryId.value);
  if (!errorAction.value) {
    textValue.value = "";
    successAction.value = true;
  }
};

const errorAction = computed(() => {
  return gameStore.errors.find((error) =>
    error.path.includes("actionSuggestion")
  );
});

const categories = computed(() => {
  return gameStore.allCategories;
});

const categoriesOptions = computed(() => {
  return categories.value.map((category) => ({
    label: category.name,
    value: category.id,
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "out-side-closable": true,
    "all-draggable": false,
    "dialog-id": props.dialogId
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrimaryLabel, {
          text: "Proposer une suggestion d'action",
          class: "mb-2 text-left"
        }),
        _createVNode(ExtraSmallText, {
          class: "text-custom-lightGray text-left",
          text: "Personne ne pourra voir la suggestion hormis les admin tant que\n        celle-ci ne sera pas validée par ces derniers. Entrer une idée d'action\n        que nous étudierons et modifierons potentiellement afin de l'intégrer\n        au jeu et en faire profiter tout le monde ! Merci beaucoup !"
        }),
        _createVNode(PrimaryLabel, {
          text: "Action :",
          class: "text-left"
        }),
        _createVNode(InputTextarea, {
          name: "action",
          placeholder: "Julie fais 3 pompes ou boit 4 gorgées.",
          id: "action",
          is_required: true,
          modelValue: textValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event))
        }, null, 8, ["modelValue"]),
        (errorAction.value)
          ? (_openBlock(), _createBlock(ErrorText, {
              key: 0,
              text: errorAction.value.message,
              class: "mt-2 text-left"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(PrimaryLabel, {
          text: "Categorie :",
          class: "text-left"
        }),
        _createVNode(InputSelectOption, {
          modelValue: categoryId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((categoryId).value = $event)),
          options: categoriesOptions.value
        }, null, 8, ["modelValue", "options"]),
        (successAction.value)
          ? (_openBlock(), _createBlock(SuccessText, {
              key: 1,
              text: "La proposition a bien été envoyée !"
            }))
          : _createCommentVNode("", true),
        _createVNode(PrimaryButton, {
          onClick: onSubmit,
          label: "Proposer"
        })
      ])
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})